import { LearningPortfolioAttachmentDto } from './learning-portfolio.dto';

export class LearningPortfolioAttachment {
    readonly id: string;
    readonly filename: string;
    readonly url: string;

    constructor(dto: LearningPortfolioAttachmentDto) {
        this.id = dto.id;
        this.filename = dto.filename;
        this.url = dto.url;
    }
}
